import { FC } from "react";
import { Box, useTheme } from "@mui/material";
import { Icon, iconCircleExclamation } from "theme/icons";

type Props = {
  color?: string;
  position?: "absolute" | "relative";
};

export const ConsentWarningIcon: FC<Props> = ({ color, position }) => {
  const theme = useTheme();

  console.log("Rendering ConsentWarningIcon", position);

  return (
    <Box
      sx={{
        background: position === "absolute" ? "white" : undefined,
        height: "18px",
        width: "18px",
        borderRadius: "50%",
        position: position ? position : undefined,
        top: position === "absolute" ? "-1px" : undefined,
        right: position === "absolute" ? "-1px" : undefined,
      }}
    >
      <Icon
        sx={position === "absolute" ? { position: "absolute", top: "-3px", left: "-3px" } : null}
        name={iconCircleExclamation}
        htmlColor={color ? color : theme.palette.warning.main}
      />
    </Box>
  );
};
